import script from "./TimbreEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimbreEditor.vue?vue&type=script&setup=true&lang=ts"

import "./TimbreEditor.vue?vue&type=style&index=0&id=59ed0a16&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ed0a16"]])

export default __exports__